import { FC, PropsWithChildren } from "react";
import { Badge, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { sanitize } from "src/utils/string";
import clock from "../../assets/icons/clock.svg";

type ListsCardProps = {
  liveBadgeText?: string;
  programId?: number;
  startAt?: string;
  status?: number;
  title: string;
  upperTitle?: string;
  sportEnName?: string;
  cover?: string;
  id?: number;
  isLive?: boolean;
};

const ListsCard: FC<ListsCardProps> = ({
  programId,
  title,
  upperTitle,
  cover,
  startAt,
  isLive,
}) => {
  return (
    <Link
      to={`/program/${programId}/${sanitize(title)}`}
      style={{ margin: "0 5px" }}
    >
      <Card
        className="selectableItem"
        style={{
          width: "26rem",
          backgroundColor: "#262626",
          border: "none !important",
          marginTop: 0,
          borderRadius: "20px",
        }}
      >
        <div style={{ position: "relative" }}>
          <Badge
            style={{
              position: "absolute",
              top: 9,
              right: 9,
              color: "#F0F0F0",
              backgroundColor: "rgba(73, 73, 73, 0.8)",
              fontSize: "0.9rem",
              fontWeight: "400",
              display: "flex",
              alignItems: "center",
              padding: "6px 6px",
            }}
            pill
            variant="secondary"
          >
            {isLive ? (
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  background: "#B71C1C",
                  borderRadius: "14px",
                  flex: "none",
                  order: "0",
                  flexGrow: "0",
                  margin: " 4px",
                }}
              />
            ) : (
              <img
                src={clock}
                alt="clock"
                width={20}
                height={20}
                style={{ margin: "2px" }}
              />
            )}{" "}
            <span style={{ margin: "3px 3px 0 0" }}>{startAt}</span>
          </Badge>{" "}
          <Card.Img
            variant="top"
            src={cover}
            style={{
              maxHeight: "14rem",
              width: "100%",
              borderRadius: "20px 20px 0px 0px",
            }}
          />
        </div>
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {title}
          </Card.Title>
          <Card.Text
            style={{
              color: "#9E9E9E",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {upperTitle}
          </Card.Text>
        </Card.Body>
      </Card>
    </Link>
  );
};

export default ListsCard;
